// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__VDwsO","right":"styles_right__3dLZC"};